import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export abstract class ContentService {
  abstract getContent(key: string, lang?: string, responseType?: string): Observable<any>;
  abstract setClient(clientName: string): void;
}

@Injectable()
export class FakeContentService extends ContentService {

  getContent(key: string, lang?: string, responseType?: string): Observable<any> {
    return of({});
  }

  setClient(clientName: string): void { }
}